import React from 'react';
import DefaultLayout from '../../layout/DefautlLayout';
import Header from './../../components/header/Header';
import teamMember from '../../models/teamMembers';
import styled from './aboutPage.module.css';

const TeamMember = ({ content, reveseDirection }) => {
	const { name, title, subTitle, image, description } = content;

	return (
		<div className={`section_wrapper mcb-section-inner hrmargin_b_30${reveseDirection ? ' d-md-flex row-reverse' : ''}`}>
			<div className="wrap mcb-wrap one-third valign-middle clearfix">
				<div className="mcb-wrap-inner">
					<div className="column mcb-column one column_image">
						<div className="image_frame image_item no_link scale-with-grid aligncenter no_border">
							<div className="image_wrapper">
								<img className="scale-with-grid" src={!!image ? image : '/assets/images/200x200.jpg'} alt={name + ' pic'} />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				className="wrap mcb-wrap two-third valign-middle clearfix"
				style={{
					padding: '0 0 0 5%',
				}}>
				<div className="mcb-wrap-inner">
					<div className="column mcb-column one column_column column-margin-30px">
						<div className="column_attr clearfix">
							<h3>{title}</h3>
							<hr
								className="no_line"
								style={{
									margin: '0 auto 5px',
								}}
							/>
							{!!subTitle && <h6 className="insurance3-heading bg-theme">{subTitle}</h6>}
							<hr
								className="no_line"
								style={{
									margin: '0 auto 15px',
								}}
							/>
							{description.length > 0 && description.map((d) => <p>{d}</p>)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const AboutPage = () => {
	return (
		<DefaultLayout>
			<Header />

			<div id="Content">
				<div className="content_wrapper clearfix">
					<div className="sections_group">
						<div className="extra_content">
							<div
								className="section mcb-section bg-cover"
								style={{
									paddingTop: '0px',
									paddingBottom: '0px',
									backgroundImage: 'url(/assets/images/banners/about-us-xl-2.png)',
									backgroundRepeat: 'no-repeat',
									backgroundPosition: 'right bottom',
								}}>
								<div className="section_wrapper mcb-section-inner">
									<div
										className="wrap mcb-wrap one valign-top clearfix"
										style={{
											padding: '30% 0 10%',
										}}>
										<div className="mcb-wrap-inner">
											<div className="column mcb-column one-second column_column">
												<div className={`clearfix ${styled.bannerTextWidth}`}>
													<h2>About Us</h2>
													<hr
														className="no_line"
														style={{
															margin: '0 auto 15px',
														}}
													/>
													<p>
														<strong>
															Sitara Medical Clinic is committed to assisting our patients in achieving their beauty & aesthetic
															goals.
														</strong>{' '}
														Sitara Clinic's goal is to be the luxurious cosmetic clinic of choice for beauty. We don't focus on
														genetics. To achieve the high-end, flawless look that leads our patients to the life of their dreams, we
														battle any flaw that is possible.
													</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className={styled.pusherDiv}></div>

							<div className="section center bg-theme" style={{ paddingTop: '30px', paddingBottom: '15px' }}>
								<div className="section_wrapper clearfix">
									<div className="items_group clearfix">
										<div className="column_attr">
											<h3 className="text-light" style={{ letterSpacing: '3px', marginBottom: 0 }}>
												Sitara Medical Clinic
											</h3>
											<h4 className="text-light">#1 Cosmetic Clinic in Ireland</h4>
										</div>
									</div>
								</div>
							</div>

							<div
								className="section mcb-section"
								style={{
									paddingTop: '110px',
									paddingBottom: '70px',
									// backgroundImage: "url(./assets/images/insurance3-sectionbg3.png)",
									backgroundRepeat: 'repeat-x',
									backgroundPosition: 'center top',
								}}>
								{!!teamMember &&
									teamMember.length > 0 &&
									teamMember.map((m, i) => <TeamMember key={i} content={m} reveseDirection={i % 2 !== 0} />)}

								<div className="section section-post-about">
									<div className="section_wrapper clearfix">
										<div className="column one author-box">
											<div className="author-box-wrapper">
												<div className="avatar-wrapper">
													<img
														src="http://2.gravatar.com/avatar/b8da4787ca5ff7a6bb9bbabecce2daa2?s=64&amp;r=g"
														className="avatar avatar-64 photo"
														height="64"
														width="64"
														alt=""
													/>
												</div>
												<div className="desc-wrapper bg-theme">
													<h3 className="text-light">Want to join Sitara Clinic?</h3>
													<div className="desc text-light">
														We are always looking for enthusiastic people who are devoted to excellence to work with us. If this
														sounds like you,{' '}
														<a
															href="https://mail.google.com/mail/?view=cm&fs=1&to=sitaramedclinic@gmail.com&su=Application%20to%20Join%20Sitara%20Medical%20Clinic%20Team&body=Hello%20Sitara%20Medical%20Clinic%20Team%2C%0A%0AMy%20name%20is%20%5BYour%20Name%5D%2C%20I%E2%80%99m%20an%20enthusiastic%20and%20devoted%20professional%20eager%20to%20join%20your%20team%20and%20contribute%20to%20your%20reputation%20for%20excellence.%20%0A%0AI%27d%20love%20to%20discuss%20how%20my%20skills%20and%20experience%20can%20support%20Sitara%20Medical%20Clinic%27s%20mission.%0A%0AThank%20you%20for%20your%20consideration.%0A%0ARegards%2C%0A%5BYour%20Name%5D"
															target="_blank"
															rel="noopener noreferrer">
															please send us an email
														</a>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</DefaultLayout>
	);
};

export default AboutPage;
